import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
  DragEndEvent,
  MouseSensor,
} from '@dnd-kit/core'
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import { useFormikContext } from 'formik'
import { DisplayRelatedProduct } from './DisplayRelatedProduct'

export const DraggableProducts = ({
  remove,
  type,
  products,
}: {
  remove: (index: number) => void
  type: 'equivalentProducts' | 'alternativeProducts'
  products: { gtin: string; referencedTradeItemTypeCode: string }[]
}) => {
  const { setFieldValue } = useFormikContext()
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 25 } }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
    useSensor(MouseSensor)
  )

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event

    if (over && active.id !== over?.id) {
      const oldIndex = products.findIndex((i) => i.gtin === active.id)
      const newIndex = products.findIndex((i) => i.gtin === over.id)

      const newArray = arrayMove(products, oldIndex, newIndex)
      setFieldValue(type, newArray)
    }
  }

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}>
      <SortableContext
        items={products.map((i) => i.gtin)}
        strategy={verticalListSortingStrategy}>
        {products.map((product) => {
          return (
            <DisplayRelatedProduct
              product={product}
              type={type}
              remove={remove}
              key={product.gtin + product.referencedTradeItemTypeCode}
            />
          )
        })}
      </SortableContext>
    </DndContext>
  )
}
